<ng-container *ngIf="user">

    <div class="row">
        <div class="col-12">
           <user-core #userCoreComponent
                      [idPrefix]="idPrefix"
                      [(bananaBox)]="user"
                      [disabled]="disabled">
           </user-core>
        </div>
    </div>

    <div class="row mt-2">

        <div class="col-12">
            <mat-tab-group class="smp-tab-style">

                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-label-label">{{ 'user_management.tab.address' | translate }}</span>
                        <mat-icon *ngIf="userAddressComponent && !userAddressComponent?.valid()" class="mat-tab-label-error-icon ml-2" aria-hidden="false" aria-label="Errors">error</mat-icon>
                    </ng-template>

                    <div>
                        <user-address #userAddressComponent
                                      [idPrefix]="idPrefix"
                                      [(bananaBox)]="user"
                                      [disabled]="disabled">
                        </user-address>
                    </div>
                </mat-tab>

                <mat-tab label="{{ 'user_management.tab.additional_data' | translate }}">
                    <div>
                        <user-additional-data #userAdditionalDataComponent
                                              [idPrefix]="idPrefix"
                                              [(bananaBox)]="user"
                                              [disabled]="disabled">
                        </user-additional-data>
                    </div>
                </mat-tab>

                <mat-tab label="{{ 'user_management.tab.client_settings' | translate }}">
                    <div>
                        <user-client-settings #userClientSettingsComponent
                                              [idPrefix]="idPrefix"
                                              [(bananaBox)]="user"
                                              [assignments]="assignments"
                                              [disabled]="disabled">
                        </user-client-settings>
                    </div>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        <span class="tab-label-label">{{ 'user_management.tab.permissions' | translate }}</span>
                        <mat-icon *ngIf="userPermissionRolesComponent && !userPermissionRolesComponent?.valid()" class="mat-tab-label-error-icon ml-2" aria-hidden="false" aria-label="Errors">error</mat-icon>
                    </ng-template>

                    <div>
                        <user-permission-roles #userPermissionRolesComponent
                                               [idPrefix]="idPrefix"
                                               [(bananaBox)]="user"
                                               [roles]="roles"
                                               [disabled]="disabled">
                        </user-permission-roles>
                    </div>
                </mat-tab>

            </mat-tab-group>
        </div>
    </div>

    <div class="row mt-4">
        <div class="offset-lg-6 col-xs-12 col-md-6 col-lg-3">
            <button id="{{idPrefix}}btn.save"
                    mat-flat-button
                    color="accent"
                    class="full-width"
                    (click)="submit()">
                {{ 'common.btn.save' | translate | uppercase }}
            </button>
        </div>

        <div class="col-xs-12 col-md-6 col-lg-3">
            <a id="{{idPrefix}}btn.cancel"
               mat-stroked-button
               color="primary"
               class="full-width"
               (click)="cancel()">
                {{ 'common.btn.cancel' | translate | uppercase }}
            </a>
        </div>
    </div>

</ng-container>
